import React from 'react'
import { Button as TdsButton } from '@instacart/tds'
import './OrderEntryHostFrame.scss'

type OrderEntryHostFrameProps = {
  onClose: () => void
  children: React.ReactNode
}

export const OrderEntryHostFrame = ({ onClose, children }: OrderEntryHostFrameProps) => (
  <div className="oe-host-frame">
    <div className="oe-host-frame__header">
      <TdsButton variant="secondary" onClick={onClose}>
        Back to Orders
      </TdsButton>
    </div>
    <div className="oe-host-frame__content">{children}</div>
  </div>
)
